import ax from './../http-common'
const actions = {
  // Getting posts
  getPosts ({ commit }) {
    return ax.HTTP.get('/posts')
  },
  hb ({ commit }) {
    return ax.HTTP3.get('/hb?token=')
  },
  login ({ commit }, formData) {
    let data = new URLSearchParams()

    data.append('email', formData.email)
    data.append('password', formData.password)
    data.append('rememberMe', formData.rememberMe)
    return ax.HTTP3.post('/login', data)
  },
  logout ({ commit }, token) {
    return ax.HTTP3.get(`/logout?token=${token}`)
  },
  refreshToken ({ commit }, token) {
    return ax.HTTP3.get(`/renew-token?token=${token}`)
  },
  startShift ({ commit }, inspectionData) {
    let token = this.state.user.token
    let data = new URLSearchParams()

    data.append('token', token)
    data.append('odometer', inspectionData.odometer)
    data.append('imagesOdometer', JSON.stringify(inspectionData.imagesOdometer))
    data.append('tireTread', inspectionData.tireTread)
    data.append('brakes', inspectionData.brakes)
    data.append('safetyEquipment', inspectionData.safetyEquipment)
    data.append('suppliesSafety', inspectionData.suppliesSafety)
    data.append('documentation', inspectionData.documentation)
    data.append('lights', inspectionData.lights)
    data.append('time', inspectionData.time)

    return ax.HTTP3.post(`/shift/start`, data)
  },
  endShift ({ commit }, dataObj) {
    let data = new URLSearchParams()
    let token = this.state.user.token
    data.append('token', token)
    data.append('id', dataObj.shiftId)
    data.append('time', dataObj.time)
    data.append('odometer', dataObj.odometer)
    data.append('imagesOdometer', JSON.stringify(dataObj.imagesOdometer))
    return ax.HTTP3.post(`/shift/end`, data)
  },
  startWorkday ({ commit }, dataObj) {
    let token = this.state.user.token
    let data = new URLSearchParams()

    data.append('token', token)
    data.append('time_start', dataObj.timeStart)

    return ax.HTTP3.post(`/workday/start`, data)
  },
  endWorkday ({ commit }, dataObj) {
    let token = this.state.user.token
    let data = new URLSearchParams()

    data.append('token', token)
    data.append('time_end', dataObj.timeEnd)
    data.append('workday_id', dataObj.workdayId)

    return ax.HTTP3.post(`/workday/end`, data)
  },
  sendImages ({ commit }, imagesArray) {
    let token = this.state.user.token
    let images = JSON.stringify(imagesArray)
    let data = new URLSearchParams()
    data.append('token', token)
    data.append('images', images)
    return ax.HTTP3.post(`/images/upload-photo`, data)
  },
  sendSignature ({ commit }, signatureArray) {
    let token = this.state.user.token
    let signatures = JSON.stringify(signatureArray)
    let data = new URLSearchParams()
    data.append('token', token)
    data.append('signatures', signatures)

    return ax.HTTP3.post(`/images/upload-signature`, data)
  },
  startTrip ({ commit }, tripData) {},
  getJobs ({ commit }) {
    let token = this.state.user.token
    return ax.HTTP3.get(`/job/route-sheets?token=${token}&nocache=` + Math.random())
  },
  startJob ({ commit }, jobData) {
    let token = this.state.user.token
    let data = new URLSearchParams()
    data.append('token', token)
    data.append('jobId', jobData.id)
    data.append('time', jobData.startTime)
    return ax.HTTP3.post(`/job/start`, data)
  },
  endJob ({ commit }, jobData) {
    let token = this.state.user.token
    let data = new URLSearchParams()
    data.append('token', token)
    data.append('jobId', jobData.jobId)
    data.append('time', jobData.endTime)
    data.append('standsCount', jobData.standsCount)
    return ax.HTTP3.post(`/job/end`, data)
  },
  skipJob (state, skipJobObj) {
    let token = this.state.user.token
    let data = new URLSearchParams()
    data.append('token', token)
    data.append('jobId', skipJobObj.jobId)
    data.append('skipReason', skipJobObj.skipReason)
    data.append('time', skipJobObj.time)
    return ax.HTTP3.post(`/job/skip`, data)
  },
  sendJobAction ({ commit }, jobActionsData) {
    let data = new URLSearchParams()
    for (var key in jobActionsData) {
      if (Array.isArray(jobActionsData[key])) {
        data.append(key, JSON.stringify(jobActionsData[key]))
      } else {
        data.append(key, jobActionsData[key])
      }
    }
    return ax.HTTP3.post(`/job/actions`, data)
  },
  sendPiratesRequest ({ commit }, jobActionsData) {
    let data = new URLSearchParams()
    for (var key in jobActionsData) {
      if (Array.isArray(jobActionsData[key])) {
        data.append(key, JSON.stringify(jobActionsData[key]))
      } else {
        data.append(key, jobActionsData[key])
      }
    }
    return ax.HTTP3.post(`/pirates/add`, data)
  },
  sendLocationToServer ({ commit }, locationObject) {
    let token = this.state.user.token
    let dataObject = Object.assign({ token: token }, locationObject)
    let data = new URLSearchParams()
    for (var key in dataObject) {
      data.append(key, dataObject[key])
    }
    return ax.HTTP3.post(`/driver-ccordiantes/track`, data)
  },
  getCustomForms ({ commit }) {
    let token = this.state.user.token
    return ax.HTTP3.get(`/forms/receive?token=${token}`)
  },
  sendCustomFormsData ({ commit }, dataObject) {
    let data = new URLSearchParams()
    for (var key in dataObject) {
      if (Array.isArray(dataObject[key])) {
        data.append(key, JSON.stringify(dataObject[key]))
      } else {
        data.append(key, dataObject[key])
      }
    }
    return ax.HTTP3.post(`/forms/send`, data)
  },
  uploadState ({ commit }, state) {
    let token = this.state.user.token
    let data = new URLSearchParams()
    data.append('token', token)
    data.append('state', JSON.stringify(state))
    return ax.HTTP3.post(`/state/send`, data)
  },
  getStateFromServer ({ commit }, token) {
    return ax.HTTP3.get(`/state/receive?token=${token}`)
  },
  sendCustomFormData ({ commit }, dataObject) {
    let data = new URLSearchParams()
    for (var key in dataObject) {
      if (Array.isArray(dataObject[key])) {
        data.append(key, JSON.stringify(dataObject[key]))
      } else {
        data.append(key, dataObject[key])
      }
    }
    return ax.HTTP3.post(`/job/create`, data)
  },
  getDriverInfo ({ commit }) {
    let data = new URLSearchParams()
    let token = this.state.user.token
    data.append('token', token)
    let activeJob = this.state.activeJob
    if (activeJob && activeJob.isStarted && activeJob.id) {
      data.append('jobId', activeJob.id)
    }
    return ax.HTTP3.post(`/accident/info`, data)
  },
  sendAccidentInfo ({ commit }, dataObj) {
    let data = new URLSearchParams()
    dataObj.token = this.state.user.token
    for (var key in dataObj) {
      if (Array.isArray(dataObj[key])) {
        data.append(key, JSON.stringify(dataObj[key]))
      } else {
        data.append(key, dataObj[key])
      }
    }
    return ax.HTTP3.post(`/accident/create`, data)
  },
  getMonthlyAuditDriverInfo ({ commit }) {
    let data = new URLSearchParams()
    let token = this.state.user.token
    data.append('token', token)
    return ax.HTTP3.post(`/vehicle-audit/info`, data)
  },
  sendMonthlyAuditDriverInfo ({ commit }, dataObj) {
    let data = new URLSearchParams()
    dataObj.token = this.state.user.token
    for (var key in dataObj) {
      data.append(key, dataObj[key])
    }
    return ax.HTTP3.post(`/vehicle-audit/create`, data)
  }
}

export default actions
